// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__jl-Ft","select":"Header_select__3UHoP","clinic":"Header_clinic__3r72j"};